module.exports = __webpack_public_path__ + "static/moon_mobile_720p-b65395a4c351ff651f28f33b2b6ff290.mp4";